const MIN_AGE = 18;

// eslint-disable-next-line import/prefer-default-export
export const PATIENT_COVERAGE_VALIDATIONS = {
  insurancePhone: {
    label: 'Insurance Phone Number',
    presence: { allowEmpty: false },
    serverErrors: { key: 'patientCoverage.insurancePhone', skipLabelPrefix: true },
    length: { minimum: 10, maximum: 20 },
  },
  memberId: {
    label: 'Member ID',
    presence: { allowEmpty: false },
    length: { minimum: 2 },
  },
  group: {
    label: 'Group ID',
    presence: { allowEmpty: false },
    length: { minimum: 2 },
  },
  employer: {
    presence: { allowEmpty: false },
    length: { minimum: 2 },
  },
  subscriberGivenName: {
    label: 'First name',
    presence: { allowEmpty: false },
    length: { minimum: 2 },
  },
  subscriberFamilyName: {
    label: 'Last name',
    presence: { allowEmpty: false },
    length: { minimum: 2 },
  },
  subscriberBirthDate: {
    label: 'Birthday',
    presence: { allowEmpty: false },
    age: {
      minimum: MIN_AGE,
      tooYoung: 'The subscriber should be at least 18 years old.',
    },
  },
};
